// extracted by mini-css-extract-plugin
module.exports = {"handle-control":"slider-module__handle-control___25F-D","handleControl":"slider-module__handle-control___25F-D"};